/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1697a9ad&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1697a9ad"]])

export default __exports__